export const ACTIVE_SWITCHER_ADJUST = 'ACTIVE_SWITCHER_ADJUST';
export const ACTIVE_SWITCHER_STOP = 'ACTIVE_SWITCHER_STOP';

export const ADJUST_WITHDRAWAL = 'ADJUST_WITHDRAWAL';
export const STOP_WITHDRAWAL = 'STOP_WITHDRAWAL';
